import React from "react"
import './Surrounding.css'

const Surrounding = () => {
  return (
    <div>
      <div className="aboutsurrounding" data-aos="fade-up"
        data-aos-duration="1000">
        <video src="./AboutPhotos/Surrounding/surroundings.mp4" controls></video>
      </div>
    </div>
  )
}

export default Surrounding
